<template>
<m-pageframe
    title="Bulk Message Templates"
>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px;"
    grid-list-xl
>

    <m-bulk-message-template-type-cards
        v-on:create-message="onClickCreateMessage"
        v-on:view-all="onClickViewAll"
    />

    <m-bulk-message-template-create-bulk-message-dialog
        ref="create_dialog"
    />

    <m-bulk-message-template-view-all-dialog
        ref="view_all_dialog"
        v-on:create="onClickCreateMessage"
    />
    
</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
        }
    },


    methods: {
        onClickCreateMessage(item) {
            this.$refs['create_dialog'].showDialog(item);
        },

        onClickViewAll(item)
        {
            this.$refs['view_all_dialog'].showDialog(item);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>